'use client';
import styled from 'styled-components';

export const CheckboxContainer = styled.div`
  display: grid;
  grid-gap: ${props => props.theme.spacing(3)};
  grid-template-columns: 1fr 1fr;
  width: 100%;
`;

export const MultiSelectContainer = styled.div`
  margin-top: ${props => props.theme.spacing(6)};
  text-align: left;
  width: 100%;
`;

export const FieldWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing(1)};
  width: 100%;
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: calc(100vh - 76px);
  overflow: hidden;
  img {
    width: 100%;
  }
  @media ${props => props.theme.laptop} {
    width: 50%;
    img {
      object-fit: cover;
    }
  }
`;

export const DesktopImageContainer = styled.div`
  display: none;
  height: 100%;

  @media ${props => props.theme.laptop} {
    display: flex;
    img {
      height: 100vh !important;
    }
  }
`;
export const MobileImageContainer = styled.div`
  overflow: hidden;

  @media ${props => props.theme.laptop} {
    display: none;
  }
`;

export const ArrowContainer = styled.div`
  display: flex;
  position: absolute;
  top: 10px;
  left: 10px;
  gap: ${props => props.theme.spacing(4)};
  max-width: 350px;
  width: 100%;
  button {
    background-color: #37332db2;
    border: none;
  }
`;

export const ButtonContainer = styled.div`
  margin: ${props => props.theme.spacing(5, 0, 8)};
`;
